export const assets = {
  logo: '/assets/logo.webp',
  hero: '/assets/kitchen-detail-gloss-v4.webp',
  kitchenWide: '/assets/kitchen-wide-gloss-v4.webp',
  kitchenOverview: '/assets/kitchen-overview-gloss-v4.webp',
  team: '/assets/team-ai-v2.webp',
  factory: '/assets/factory-ai-v2.webp',
  brand: '/assets/brand-ai-v2.webp',
  wok: '/assets/wok-gloss-v4.webp',
  fridge: '/assets/fridge-gloss-v4.webp',
  workbench: '/assets/workbench-gloss-v4.webp',
  western: '/assets/western-gloss-v4.webp',
  oven: '/assets/oven-gloss-v4.webp'
}

export const documents = {
  productCatalog: '/assets/product-catalog.pdf',
  companyProfile: '/assets/company-profile.pdf'
}

export const homeSlides = [
  { title: 'COMMERCIAL KITCHENWARE', subtitle: '专业厨房设备 · 一站式整体解决方案\n让每一处细节，服务每一次出品。', imageUrl: assets.hero, linkUrl: '/solutions' },
  { title: 'BUILT FOR PERFORMANCE', subtitle: '从空间规划到设备交付\n让专业厨房保持高效、有序。', imageUrl: assets.kitchenWide, linkUrl: '/products' },
  { title: 'FROM PLAN TO SERVICE', subtitle: '设计 · 制造 · 安装 · 售后\n完整流程，支持每一次稳定运营。', imageUrl: assets.kitchenOverview, linkUrl: '/service' }
]

export const pageMeta = {
  SOLUTION: { position: 'SOLUTION', eyebrow: 'TAILORED SOLUTIONS', title: '为不同的厨房，找到共同的从容。', subtitle: '以运营需求为起点，让空间、设备和工作流程协同。', image: assets.kitchenWide, sectionEyebrow: 'TAILORED SOLUTIONS / 解决方案', sectionTitle: '每一种餐饮理想，都有合适的厨房。' },
  PRODUCT: { position: 'PRODUCT', eyebrow: 'PRODUCT COLLECTION', title: '专业设备，有序协作。', subtitle: '中餐炉具、制冷设备、不锈钢定制与厨房配套。', image: assets.kitchenWide, sectionEyebrow: 'PROFESSIONAL EQUIPMENT / 产品中心', sectionTitle: '为专业厨房，配置可靠设备。' },
  CASE: { position: 'CASE', eyebrow: 'SELECTED PROJECTS', title: '好厨房，走进真实的餐饮现场。', subtitle: '从品牌门店到公共食堂，呈现时代厨房资料中的项目。', image: assets.hero, sectionEyebrow: 'PROJECTS WE DO / 工程案例', sectionTitle: '从方案出发，让专业落地。' }
}

export const fallbackContents = {
  SOLUTION: [
    { detailSlug: 'restaurant', title: '连锁餐饮厨房', categoryName: 'RESTAURANTS', subtitle: 'TAILORED SOLUTIONS', summary: '围绕品牌菜单、峰值客流和标准化工位，统筹厨房空间。', coverImage: assets.hero },
    { detailSlug: 'hotel', title: '酒店餐饮厨房', categoryName: 'HOTELS & HOSPITALITY', subtitle: 'TAILORED SOLUTIONS', summary: '兼顾宴会、零点餐厅与后勤供餐的复合运营需求。', coverImage: assets.kitchenWide },
    { detailSlug: 'canteen', title: '学校与企事业食堂', categoryName: 'INSTITUTIONAL KITCHENS', subtitle: 'TAILORED SOLUTIONS', summary: '面向集中供餐场景，规划高效、清晰的生产动线。', coverImage: assets.kitchenOverview },
    { detailSlug: 'central', title: '中央厨房', categoryName: 'CENTRAL KITCHENS', subtitle: 'TAILORED SOLUTIONS', summary: '围绕加工、分装、储运与清洗构建完整生产体系。', coverImage: assets.team }
  ],
  PRODUCT: [
    { detailSlug: 'wok', title: '环保节能型双头小炒炉', categoryName: '中餐炉具', subtitle: 'CHINESE COOKING', summary: '为中式餐饮热厨配置双头烹饪工位，配合后厨操作动线规划。', coverImage: assets.wok, extraJson: '{"图像说明":"AI 产品示意图，实物外观以确认资料为准","产品资料":"《时代画册》第 17 个 PDF 页面","配置方式":"结合厨房空间、能源条件与使用需求确认","型号与报价":"联系咨询，获取适合项目的设备配置"}', sourceHref: `${documents.productCatalog}#page=17`, sourceLabel: '查看画册原页' },
    { detailSlug: 'fridge', title: '推入式雪柜', categoryName: '制冷设备', subtitle: 'REFRIGERATION', summary: '面向餐饮后厨冷藏周转场景，结合储存量和操作动线配置。', coverImage: assets.fridge },
    { detailSlug: 'workbench', title: '双通打荷台', categoryName: '不锈钢定制', subtitle: 'STAINLESS STEEL', summary: '连接备餐与出品工位，为双侧操作和物料周转提供支持。', coverImage: assets.workbench },
    { detailSlug: 'western', title: '西餐组合炉', categoryName: '西餐与烘焙', subtitle: 'WESTERN & BAKERY', summary: '围绕西餐热厨工作流程组合烹饪设备与操作工位。', coverImage: assets.western },
    { detailSlug: 'oven', title: '电烤箱', categoryName: '西餐与烘焙', subtitle: 'WESTERN & BAKERY', summary: '适用于烘焙与西餐制作场景，具体层数和功率按项目确认。', coverImage: assets.oven },
    { detailSlug: 'dishwasher', title: '通道式洗碗机', categoryName: '洗消设备', subtitle: 'DISHWASHING', summary: '服务餐具回收与集中洗消流程，配置需结合峰值餐量和场地条件。', coverImage: assets.kitchenOverview }
  ],
  CASE: [
    { detailSlug: 'tanyu', title: '探鱼', categoryName: '全国连锁餐饮', summary: '标准化设备与门店厨房动线协同。', coverImage: assets.hero, sourceHref: `${documents.productCatalog}#page=8`, sourceLabel: '查看原始项目资料' },
    { detailSlug: 'tanshe', title: '炭舍', categoryName: '连锁餐饮', summary: '围绕业态需求配置热厨、备餐与洗消空间。', coverImage: assets.kitchenWide },
    { detailSlug: 'dalong', title: '大龙燚火锅', categoryName: '连锁火锅餐饮', summary: '围绕高峰客流与火锅业态组织厨房设备和工作流程。', coverImage: assets.kitchenOverview }
  ]
}

export function findFallbackContent(module, slug) {
  return (fallbackContents[module] || []).find(item => item.detailSlug === slug) || null
}

export const processSteps = [
  { title: '需求与设计', text: '从菜式、场地与运营需求出发，规划布局与设备清单。' },
  { title: '制造与配套', text: '结合项目条件组织设备生产、加工及选配。' },
  { title: '安装与调试', text: '现场衔接、设备安装与调试，让方案落到实处。' },
  { title: '售后与支持', text: '提供设备使用咨询、维护协助与售后联络。' }
]
